import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { BazisAlertComponent } from '@bazis/shared/components/alert/alert.component';
import { AsyncPipe } from '@angular/common';
import { BazisCoreSharedModule } from '@bazis/shared/core-shared.module';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    imports: [AsyncPipe, BazisCoreSharedModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent extends BazisAlertComponent {
    @ViewChild('dialogAlert') set dialogAlertEl(el: ElementRef) {
        if (!el) return;

        this.alertEl = el.nativeElement;
        this.alertEl.showModal();
    }

    alertEl;

    dismiss(action = null) {
        if (!this.alertEl) return;
        this.alertEl.close();
        super.dismiss(action);
    }
}
